import { styled } from "styled-components";

export const CategoryItem = styled.div`
  width: 100%;
  height: 100%;

  cursor: pointer;
`;
